import {
  startToolOperation,
  type ToolAnalyticsContext,
  type ToolOperation,
} from '@saas-pages/shared/public/runtime'

const ANALYTICS_CONTEXT = {
  app: 'dateify',
  domain: 'dateify.ru',
  route: '/rabochie-dni-mezhdu-datami',
  utility: 'business-days-calculator',
  processingMode: 'local',
} satisfies ToolAnalyticsContext

export function startFederalCalendarOperation(): ToolOperation {
  return startToolOperation(ANALYTICS_CONTEXT)
}
